import React from "react";
import { connect } from "react-redux";
import * as _ from 'lodash';
import { Alert } from 'react-bootstrap'
import { IAppState } from "../../state/interfaces";
import { IOfferErrors, IVehicleBase } from "../../classes/Domain";
import Utilities from "../../classes/Utilities";

export interface IProps {
    offerErrors: IOfferErrors,
    vehicle: IVehicleBase;
}

class VehicleMSRPMaximum extends React.Component<IProps> {
    componentDidMount() {
        
    }

    render() {
        return (
            <div>
                <Alert variant={"warning"} className="m-t-20">
                    <p className="message-body">
                        {Utilities.formatVehicle(this.props.vehicle)} value exceeds the system’s limit for policy issuance. Please contact customer service at (214) 347-7217
                    </p>
                </Alert>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IProps) => {
    const vehicle = _.find(state.vehicles, (v) => v.vin === ownProps.offerErrors.domainKey);

    return {
        ...ownProps,
        vehicle: vehicle,
        selectedCoverageConfig: state.coverageConfig
    };
};

export default connect(mapProps, null)(VehicleMSRPMaximum);
